import { createContext } from "react";

const Context = createContext<[void, any]>([undefined, {}]);

export default Context;
